import React, { Suspense } from 'react';
import CircularProgress from '../../../components_base/CircularProgress';

const AccountBalnce = React.lazy(() => import('../components/AccountBalance'));
function AccountBalanceView(props: any) {
  return (
    <Suspense fallback={<CircularProgress />}>
      <AccountBalnce {...props} />
    </Suspense>
  );
}

export default AccountBalanceView;
